// @ts-strict

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StatisticsGraphsService } from '@services/statistics/statistics-graphs.service';
import { GraphFilterOption } from '@pages/statistics/shared/interfaces/statistics';

@Component({
  selector: 'app-select-data-menu',
  templateUrl: './select-data-menu.component.html',
  styleUrls: ['./select-data-menu.component.scss']
})
export class SelectDataMenuComponent implements OnInit {
  @Input() filterOptions: GraphFilterOption[] = [];
  @Input() resetFilters = false;

  @Output() isMenuClosed = new EventEmitter<boolean>();
  @Output() currentSelectedFilters = new EventEmitter<GraphFilterOption[]>();

  private clickOutside = false;

  public currentFilters: GraphFilterOption[] = [];
  public errorMessage = '';
  public errors = false;

  constructor(private graphsDataService: StatisticsGraphsService) {}

  ngOnInit(): void {
    this.currentFilters = this.filterOptions.filter(filterOption => filterOption.status);
  }

  public closeMenu(): void {
    if (this.clickOutside) {
      this.close();
    }
    this.clickOutside = true;
  }

  public checkIfChecked(option: GraphFilterOption): boolean {
    const isChecked = this.filterOptions.find(filterOption => filterOption.name === option.name)?.status ?? false;

    return isChecked;
  }

  public checkboxValue(event: Event, element: GraphFilterOption, i: number): void {
    if (!this.resetFilters) {
      this.currentFilters = [
        {
          name: 'leads_together',
          translation: 'leads',
          status: false,
          fillColor: '#FF8C03',
          borderColor: '#FFF4E6'
        }
      ];
    }
    if ((event.target as HTMLInputElement).checked) {
      if (!this.currentFilters.includes(element) && this.currentFilters.length < 4) {
        this.currentFilters.push(element);
        this.filterOptions[i].status = true;
        (event.target as HTMLInputElement).checked = true;
      } else {
        this.filterOptions[i].status = true;
        for (const v of this.filterOptions.values()) {
          if (v.name === this.currentFilters[0].name) {
            v.status = false;
          }
        }
        this.currentFilters.shift();
        this.currentFilters.push(element);
      }
    } else {
      if (this.filterOptions[i].status && this.currentFilters.length > 1) {
        this.filterOptions[i].status = false;
        for (const [j, v] of this.currentFilters.entries()) {
          if (v.name === this.filterOptions[i].name) {
            this.currentFilters.splice(j, 1);
          }
        }
      } else {
        this.filterOptions[i].status = false;
        (event.target as HTMLInputElement).checked = true;
        this.currentFilters.splice(i, 1);
      }
    }

    this.currentFilters = this.currentFilters.concat([]);

    this.setDataToStorage(this.currentFilters);
    this.currentSelectedFilters.emit(this.currentFilters);
  }

  private setDataToStorage(selectedData: GraphFilterOption[]): void {
    this.graphsDataService.statisticsSelectedFilters = selectedData;
  }

  private close(): void {
    this.isMenuClosed.emit(true);
  }
}
